import PropTypes from "prop-types";
// @mui
import { TableRow, TableCell } from "@mui/material";

// components
import Label from "../../../../components/label";

import { fNumber } from "src/utils/formatNumber";
import { useAuthContext } from "src/auth/useAuthContext";

// ----------------------------------------------------------------------

CustomerOrderTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onEditRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  handleOpenUserOrderDetailModal: PropTypes.func,
};

export default function CustomerOrderTableRow({ row, handleOpenUserOrderDetailModal,getSingleData }) {
  const { orderType, createdAt, total, state, type, billNumber, paymentType } = row;

  const { user } = useAuthContext();
  const {venue} = user || {};

  const formatTime = (time) => {
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    return new Intl.DateTimeFormat("en-US", options).format(time);
  };

  const formatDate = (time) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Intl.DateTimeFormat("en-US", options).format(time);
  };

  const newCreatedAtDate = new Date(createdAt);
  var options = {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  var formattedTime = newCreatedAtDate.toLocaleString("en-US", options);

  const getDisplayOrderType = (type) => {
    switch (type) {
      case "pos":
        return "POS";
      case "foodPanda":
        return "Food Panda";
      case "web":
        return "Web";
      case "app":
        return "App";
      case "store":
        return "Store";
      default:
        return "-";
    }
  };

  const openModal = () => {
    handleOpenUserOrderDetailModal();
    getSingleData(row);
  };


  return (
    <>
      <TableRow hover onClick={openModal} sx={{ cursor: 'pointer' }}>
        <TableCell align="left">{billNumber == 0 ? "-" : billNumber}</TableCell>
        <TableCell align="left">{formatDate(new Date(createdAt))}</TableCell>
        <TableCell align="left">{formatTime(new Date(createdAt))}</TableCell>
        <TableCell align="left">{paymentType}</TableCell>
        <TableCell align="left">{orderType}</TableCell>
        {/* <TableCell align="left">{type}</TableCell> */}
        <TableCell align="left">
          <Label
            variant="soft"
            color={
              type === "pos" ? "success" : type === "app" ? "error" : "info"
            }
            sx={{ textTransform: "capitalize" }}
          >
            {getDisplayOrderType(type)}
          </Label>
        </TableCell>
        <TableCell align="left">
          <Label
            variant="soft"
            color={
              ((state === "processing" || state === "pending") && "info") ||
              (state === "noShow" && "secondary") ||
              ((state === "abort" || state === "cancelled") && "error") ||
              (state === "finished" && "warning") ||
              "success"
            }
            sx={{ textTransform: "capitalize" }}
          >
            {state}
          </Label>
        </TableCell>
        <TableCell align="left">Rs. {fNumber(total.toFixed(venue.ints), venue.decimalPoints)}</TableCell>
      </TableRow>
    </>
  );
}
